import React from "react";
import VideoPlayer from "./videoSection/VideoPlayer";

const VideoGallery = () => {
  return <VideoPlayer />;
};

export default VideoGallery;
